import React from "react";
import PropTypes from "prop-types";

export const PrinterIcon = props => {
  const { className, alt } = props;
  return (
    <svg
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      className={className}
      alt={alt}
    >
      <path
        fill="none"
        d="M16.86 19.07v14.1h17.38v-14.1h6.47v33.49h-6.47V38.42H16.86v14.14h-6.47V19.07h6.47zM55.15 29.74c3.29 0 5.9 1.06 7.82 3.16 1.92 2.11 2.88 5.03 2.88 8.75v.89H49.99c.24 2 .99 3.54 2.24 4.61 1.25 1.08 2.98 1.62 5.17 1.62 1.41 0 2.76-.24 4.06-.73 1.3-.49 2.65-1.23 4.04-2.22v4.39C62.88 52.07 59.7 53 55.96 53c-3.53 0-6.42-1.06-8.66-3.19s-3.36-4.95-3.36-8.49c0-3.4 1.04-6.19 3.11-8.34 2.07-2.16 4.77-3.24 8.1-3.24zm5.15 9.23c-.16-1.63-.66-2.9-1.49-3.82-.83-.92-1.97-1.38-3.43-1.38-1.49 0-2.68.44-3.58 1.32-.9.88-1.47 2.17-1.71 3.88H60.3zM77.54 29.74c2.88 0 5.07.61 6.59 1.83 1.52 1.22 2.28 2.93 2.28 5.12v10.96c0 .85.34 1.27 1.03 1.27.29 0 .69-.12 1.21-.37s.96-.53 1.31-.85v3.4C87.9 52.36 86.01 53 84.3 53c-1.05 0-1.87-.18-2.43-.53-.57-.35-.96-.98-1.19-1.87-2.25 1.6-4.51 2.4-6.78 2.4-1.61 0-3-.54-4.16-1.63-1.16-1.09-1.74-2.39-1.74-3.91 0-1.93.58-3.46 1.73-4.58s3.17-2.09 6.04-2.92l4.77-1.39v-1.03c0-2.19-1.33-3.28-3.98-3.28-1.36 0-2.71.31-4.05.94-1.34.62-2.57 1.54-3.67 2.76v-5.3c2.44-1.95 5.34-2.92 8.7-2.92zm-3.6 16.83c0 .82.26 1.47.78 1.97s1.16.74 1.93.74c1.29 0 2.59-.59 3.88-1.77v-5.9c-1.65.56-2.94 1.09-3.87 1.58-.93.5-1.62 1-2.06 1.51-.44.51-.66 1.14-.66 1.87zM98.3 19.07v33.49h-5.9V19.07h5.9zM109.55 24.23h.48v5.95h7.67v4.46h-7.67v10.33c0 1.01.3 1.82.91 2.45.61.62 1.44.94 2.49.94 1.38 0 2.96-.5 4.75-1.49v4.72c-2.13.94-4.12 1.41-5.99 1.41-2.53 0-4.49-.69-5.91-2.06-1.41-1.37-2.12-3.24-2.12-5.59V34.63h-3.5v-.96l8.89-9.44zM126.45 19.07v14.24h.14c1.9-2.38 4.2-3.57 6.88-3.57 2.38 0 4.3.78 5.75 2.35 1.45 1.57 2.18 3.61 2.18 6.14v14.34h-5.87V39.35c0-1.5-.36-2.7-1.07-3.58-.71-.89-1.68-1.33-2.91-1.33-.9 0-1.74.26-2.53.77-.79.51-1.65 1.36-2.58 2.54v14.82h-5.9v-33.5h5.91z"
      />
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Invoice" transform="translate(-514.000000, -644.000000)">
          <g id="Group" transform="translate(514.000000, 644.000000)">
            <circle id="Oval" fill="#0B75E0" cx="24" cy="24" r="24" />
            <path
              d="M31,20 L17,20 C15.34,20 14,21.34 14,23 L14,29 L18,29 L18,33 L30,33 L30,29 L34,29 L34,23 C34,21.34 32.66,20 31,20 Z M28,31 L20,31 L20,26 L28,26 L28,31 Z M31,24 C30.45,24 30,23.55 30,23 C30,22.45 30.45,22 31,22 C31.55,22 32,22.45 32,23 C32,23.55 31.55,24 31,24 Z M30,15 L18,15 L18,19 L30,19 L30,15 Z"
              id="Shape"
              fill="#FFFFFF"
              fillRule="nonzero"
            />
            <polygon id="Path" points="12 12 36 12 36 36 12 36" />
          </g>
        </g>
      </g>
    </svg>
  );
};

PrinterIcon.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string
};

PrinterIcon.defaultProps = {
  className: null,
  alt: null
};

export default PrinterIcon;
